import {
  createPaletteChannel,
  hexToRgbChannel,
  setFont
} from 'minimal-shared/utils'

import brandConfig from 'brandConfig'
import { createShadowColor } from '../core/custom-shadows'

// ----------------------------------------------------------------------

/**
 * Update the core theme with the settings state.
 * @contrast
 * @primaryColor
 */

export function updateCoreWithSettings(theme, settingsState) {
  const { direction, fontFamily, contrast = 'default' } = settingsState ?? {}

  const isDefaultContrast = contrast === 'default'
  const isDefaultPrimaryColor = false

  const lightPalette = theme.colorSchemes?.light.palette

  const updatedPrimaryColor = createPaletteChannel(
    brandConfig?.theme || {
      lighter: '#C8FAD6',
      light: '#5BE49B',
      main: '#00A76F',
      dark: '#007867',
      darker: '#004B50',
      contrastText: '#FFFFFF'
    }
  )

  const updateColorScheme = (scheme) => {
    const colorSchemes = theme.colorSchemes?.[scheme]

    const updatedPalette = {
      ...colorSchemes?.palette,
      ...(!isDefaultPrimaryColor && {
        primary: updatedPrimaryColor
        // secondary: updatedSecondaryColor,
      }),
      ...(scheme === 'light' && {
        background: {
          ...lightPalette?.background,
          ...(!isDefaultContrast && {
            default: lightPalette.grey[200],
            defaultChannel: hexToRgbChannel(lightPalette.grey[200])
          })
        }
      })
    }

    const updatedCustomShadows = {
      ...colorSchemes?.customShadows,
      ...(!isDefaultPrimaryColor && {
        primary: createShadowColor(updatedPrimaryColor.mainChannel)
        // secondary: createShadowColor(updatedSecondaryColor.mainChannel),
      })
    }

    return {
      ...colorSchemes,
      palette: updatedPalette,
      customShadows: updatedCustomShadows
    }
  }

  return {
    ...theme,
    direction,
    colorSchemes: {
      light: updateColorScheme('light'),
      dark: updateColorScheme('dark')
    },
    typography: {
      ...theme.typography,
      fontFamily: setFont(fontFamily)
    }
  }
}
